//モーダル
$(function(){
  var window_height = $(window).innerHeight();
  $(".page-artist__modalWrap").height(window_height);

  $(window).on("resize", function(){
    var window_height = $(window).innerHeight();
    $(".page-artist__modalWrap").height(window_height);
  })

  let modal_toggle = $(".page-artist__galleryItem");
  let modal_toggle_img = modal_toggle.eq(0).find("img");
  let modal_toggle_img_src = modal_toggle_img.attr("src");
  let modal_col = $(".page-artist__modal.vol2").find(".page-artist__modalCol");
  let modal_col_thumb = modal_col.find(".page-artist__modalThumb");
  let modal_col_img = modal_col.find("img");
  modal_col_img.attr("src", modal_toggle_img_src);
  // 画像がロードされた後にサイズを取得
  modal_toggle_img.on('load', function() {
    let modal_toggle_img_width = this.naturalWidth;
    let modal_toggle_img_height = this.naturalHeight;

    if(modal_toggle_img_height >= modal_toggle_img_width){
      modal_col_thumb.addClass("vertical");
    }
  });

  // 画像がすでにロードされている場合は、イベントを手動でトリガーする
  if (modal_toggle_img[0].complete) {
      modal_toggle_img.trigger('load');
  }
  modal_toggle.on("click", function() {
    var Index = $(this).index();
    var imgElement = $(this).find("img")[0]; // DOM要素を取得

    // 画像がロードされているか確認
    if (imgElement.complete && imgElement.naturalHeight !== 0) {
      processImageSize(imgElement);
    } else {
      // 画像がまだロードされていない場合、ロード完了時にサイズを取得
      $(imgElement).on('load', function() {
        processImageSize(this);
      });
    }

    modal_toggle_img_src = modal_toggle.eq(Index).find("img").attr("src");
    modal_col_img.attr("src", modal_toggle_img_src);
    //modal_col.fadeOut().removeClass('is-open');
    modal_col.fadeIn().addClass('is-open');
  });

  function processImageSize(img) {
    var modal_toggle_img_width = img.naturalWidth;
    var modal_toggle_img_height = img.naturalHeight;
    console.log(modal_toggle_img_width + '+' + modal_toggle_img_height);

    if (modal_toggle_img_height >= modal_toggle_img_width) {
      modal_col_thumb.addClass("vertical");
    } else {
      modal_col_thumb.removeClass("vertical");
    }
  }

  $(".page-artist__modalClose,.page-artist__modalOver").on("click", function(){
    $('.page-artist__modalCol').fadeOut().removeClass('is-open');
  });
});
